export default __webpack_public_path__ + "static/media/situation-mention-role.b6c39e40.gif";